import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Layout from '../../../../layout';
import { setNotification } from '../../../../redux/cache-slice';
import { updateCustomerData } from '../../../../redux/leaseApp/lease-app-slice';
import { useAppDispatch } from '../../../../redux/store';
import { RootState } from '../../../../redux/types';
import { APIPaths, ContactPurpose } from '../../../../types/instant-lease-api';
import { errorLogging } from '../../../../utils/logging';
import Navigation from '../../../../utils/navigation';
import ContactTemplate, {
  ContactTemplateData,
} from '../../templates/contact-template/contact-template';

const ContactB2C: React.FC = () => {
  // Lease Application Storage
  const { activeApplication } = useSelector(
    (state: RootState) => state.leaseApp,
  );

  // Auth Storage
  const { accessToken } = useSelector((state: RootState) => state.auth);

  // Dispatch hook
  const dispatch = useAppDispatch();

  // Init history hook (used in nav)
  const navigate = useNavigate();

  // Navigation class
  const { nextRoute } = new Navigation();

  // Get private customer for b2c person
  const privateCustomer = activeApplication?.customer?.private;

  const [loading, setLoading] = useState<boolean>(false);

  // Submit Data
  const submitData = async ({
    phone_number,
    email,
    marketing_email,
    marketing_phone,
  }: ContactTemplateData) => {
    setLoading(true);
    const promises = [];

    promises.push(
      dispatch(
        updateCustomerData({
          accessToken,
          leaseApplicationId: activeApplication?.uuid || '',
          inputValue: {
            version: 'V1_BETA_1',
            email_consent_agreed: marketing_email,
            phone_consent_agreed: marketing_phone,
          },
          path: APIPaths.UPDATE_MARKETING_AGREEMENTS,
        }),
      ).unwrap(),
    );

    promises.push(
      dispatch(
        updateCustomerData({
          accessToken,
          leaseApplicationId: activeApplication?.uuid || '',
          inputValue: {
            contact_details: {
              phone_numbers: [
                {
                  value: phone_number,
                  purpose: ContactPurpose.CONTACT,
                },
              ],
              emails: [
                {
                  value: email,
                  purpose: ContactPurpose.CONTACT,
                },
              ],
            },
          },
          path: APIPaths.CONTACT_DETAILS,
        }),
      ).unwrap(),
    );

    try {
      await Promise.all(promises);
      setLoading(false);
      navigate(nextRoute());
    } catch (error) {
      // Handle failure
      setLoading(false);
      dispatch(
        setNotification({
          notificationVisibility: true,
          notificationHasError: true,
          notificationTitle: 'Das tut uns leid',
          notificationBody: 'error_unable_to_process_data',
        }),
      );
      errorLogging(
        new Error(`unable to submit email and phone number: ${error}`),
      );
    }
  };

  return (
    <Layout stepStatus heading='Kontakt'>
      <ContactTemplate
        tabButton={false}
        onSubmit={submitData}
        privateCustomer={privateCustomer}
        marketingAgreements={activeApplication?.customer?.marketing_agreements}
        loading={loading}
      />
    </Layout>
  );
};

export default ContactB2C;
